/**
 * Rounding Model:
 * 1. Multiply raw decimal by 100 (e.g., 0.950104 → 95.0104)
 * 2. Truncate to 3 decimal places using Math.floor (→ 95.010)
 * 3. Round up to nearest hundredth using Math.ceil (→ 95.01)
 *
 * @param ltvDecimal - The LTV as a decimal (e.g., 0.9501 for 95.01%)
 * @returns The rounded LTV as a percentage with 2 decimal places (e.g., 95.01)
 *
 * @example
 * fannieMaeRoundLtv(0.80010) // returns 80.01 (80.010 ceils to 80.01)
 * fannieMaeRoundLtv(0.80011) // returns 80.02 (80.011 ceils to 80.02)
 * fannieMaeRoundLtv(0.95010) // returns 95.01 (95.010 ceils to 95.01)
 * fannieMaeRoundLtv(0.95011) // returns 95.02 (95.011 ceils to 95.02)
 */
export function fannieMaeRoundLtv(ltvDecimal: number): number {
  // Handle edge cases
  if (!ltvDecimal || isNaN(ltvDecimal)) {
    return 0
  }

  // Step 1: Multiply by 100
  const ltvPercent = ltvDecimal * 100

  // Step 2: Truncate to 3 decimals using Math.floor
  const truncated = Math.floor(ltvPercent * 1000) / 1000

  // Step 3: Round up to 2 decimals using Math.ceil
  return Math.ceil(truncated * 100) / 100
}
